// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"palette-primary-color-l5-primary-400": "#786af7",
	"palette-primary-color-l5-primary-500": "#5645f5",
	"palette-primary-color-l5-primary-700": "#2a1ac2",
	"palette-accent-color-accent-400": "#3be8df",
	"palette-accent-color-accent-500": "#02d3da",
	"palette-accent-color-accent-600": "#16c2d5",
	"palette-feedback-success-color-success-400": "#74e687",
	"palette-feedback-success-color-success-500": "#49d66e",
	"palette-feedback-success-color-success-600": "#35b864",
	"palette-feedback-info-color-info-400": "#58d7ff",
	"palette-feedback-info-color-info-500": "#21bcff",
	"palette-feedback-info-color-info-600": "#1893db",
	"palette-feedback-warning-color-warning-400": "#ffc03f",
	"palette-feedback-warning-color-warning-500": "#ffa101",
	"palette-feedback-warning-color-warning-600": "#db8200",
	"palette-feedback-error-color-error-400": "#ff8469",
	"palette-feedback-error-color-error-500": "#ff4b38",
	"palette-feedback-error-color-error-600": "#db2b28",
	"allColors-color-l5-primary-100": "#eeecfe",
	"allColors-color-l5-primary-200": "#ccc7fc",
	"allColors-color-l5-primary-300": "#aaa2fa",
	"allColors-color-l5-primary-400": "#786af7",
	"allColors-color-l5-primary-500": "#5645f5",
	"allColors-color-l5-primary-600": "#3a28e3",
	"allColors-color-l5-primary-700": "#2a1ac2",
	"allColors-color-l5-primary-800": "#1809a4",
	"allColors-color-l5-primary-900": "#110677",
	"allColors-color-accent-100": "#cafded",
	"allColors-color-accent-200": "#97fbe5",
	"allColors-color-accent-300": "#62f3df",
	"allColors-color-accent-400": "#3be8df",
	"allColors-color-accent-500": "#02d3da",
	"allColors-color-accent-600": "#16c2d5",
	"allColors-color-accent-700": "#017d9c",
	"allColors-color-accent-800": "#005a7e",
	"allColors-color-accent-900": "#004168",
	"allColors-color-success-100": "#dffcdb",
	"allColors-color-success-200": "#bafab8",
	"allColors-color-success-300": "#92f299",
	"allColors-color-success-400": "#74e687",
	"allColors-color-success-500": "#49d66e",
	"allColors-color-success-600": "#35b864",
	"allColors-color-success-700": "#249a5a",
	"allColors-color-success-800": "#177c4f",
	"allColors-color-success-900": "#0e6647",
	"allColors-color-info-100": "#d2fdff",
	"allColors-color-info-200": "#a6f5ff",
	"allColors-color-info-300": "#79e8ff",
	"allColors-color-info-400": "#58d7ff",
	"allColors-color-info-500": "#21bcff",
	"allColors-color-info-600": "#1893db",
	"allColors-color-info-700": "#106eb7",
	"allColors-color-info-800": "#0a4e93",
	"allColors-color-info-900": "#06387a",
	"allColors-color-warning-100": "#fff3cb",
	"allColors-color-warning-200": "#ffe49a",
	"allColors-color-warning-300": "#fed265",
	"allColors-color-warning-400": "#ffc03f",
	"allColors-color-warning-500": "#ffa101",
	"allColors-color-warning-600": "#db8200",
	"allColors-color-warning-700": "#b86600",
	"allColors-color-warning-800": "#944c00",
	"allColors-color-warning-900": "#7b3a00",
	"allColors-color-error-100": "#ffe7d7",
	"allColors-color-error-200": "#ffcaaf",
	"allColors-color-error-300": "#ffa687",
	"allColors-color-error-400": "#ff8469",
	"allColors-color-error-500": "#ff4b38",
	"allColors-color-error-600": "#db2b28",
	"allColors-color-error-700": "#b71c26",
	"allColors-color-error-800": "#931125",
	"allColors-color-error-900": "#7a0a24",
	"allColors-color-grey-100": "#fafafb",
	"allColors-color-grey-200": "#f0f0f4",
	"allColors-color-grey-300": "#d7dae4",
	"allColors-color-grey-400": "#b4bccd",
	"allColors-color-grey-500": "#96a0b4",
	"allColors-color-grey-600": "#798294",
	"allColors-color-grey-700": "#5a6272",
	"allColors-color-grey-800": "#393f4c",
	"allColors-color-grey-900": "#24282f",
	"allColors-color-black": "#000",
	"allColors-color-white": "#fff",
	"allColors-color-l5-slate-night": "#1b1f25",
	"allColors-color-alignment-line": "#f95580",
	"allColors-color-alignment-line-dashed": "#ec2f61",
	"l5-spacers": "0,2,4,8,12,16,20,24,32,40,48,64,80",
	"top-slide-z-index": "45",
	"top-slide-with-editing-controls-z-index": "47",
	"voice-driven-base-scene-z-index": "44",
	"slide-marker-border-width": "1px",
	"bootstrap-breakpoint-md": "768px",
	"creator-xs-min-width": "0",
	"creator-sm-min-width": "1355px",
	"creator-md-min-width": "1500px",
	"creator-lg-min-width": "1790px",
	"creator-xl-min-width": "1975px",
	"color-transcript-selection": "#ffe6b2",
	"clip-creator-video-preview-panel-width": "400px"
};
export default ___CSS_LOADER_EXPORT___;
